// extracted by mini-css-extract-plugin
export default {"container":"selectInput_container__X8+4Y"};